module.exports = __webpack_public_path__ + "static/media/industry.ef139be8.png";